export const FEEDBACK_EMAIL = "feedback@codesandbox.io";
